// Public values are embedded at build time. An empty URL keeps browser requests same-origin.
export const env = {
  apiUrl: (process.env.NEXT_PUBLIC_API_URL || "").replace(/\/$/, ""),
  // MapLibre style URL (ADR-0020). Empty means no basemap: vehicles render on a plain canvas.
  mapStyleUrl: process.env.NEXT_PUBLIC_MAP_STYLE_URL || "",
};
